import _slicedToArray from "/builds/tyson-foods/1598-sustainability-reporting/jamstack/Galileo-Salame/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/builds/tyson-foods/1598-sustainability-reporting/jamstack/Galileo-Salame/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/tyson-foods/1598-sustainability-reporting/jamstack/Galileo-Salame/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/tyson-foods/1598-sustainability-reporting/jamstack/Galileo-Salame/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/tyson-foods/1598-sustainability-reporting/jamstack/Galileo-Salame/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/tyson-foods/1598-sustainability-reporting/jamstack/Galileo-Salame/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import "core-js/modules/es.array.reduce.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { Component } from "react";
import { SearchBox } from "@elastic/react-search-ui-views";
import { withSearch } from "..";
export var SearchBoxContainer = /*#__PURE__*/function (_Component) {
  _inherits(SearchBoxContainer, _Component);
  var _super = _createSuper(SearchBoxContainer);
  function SearchBoxContainer() {
    var _this;
    _classCallCheck(this, SearchBoxContainer);
    _this = _super.apply(this, arguments);
    _this.state = {
      isFocused: false
    };
    _this.handleFocus = function () {
      _this.setState({
        isFocused: true
      });
    };
    _this.handleBlur = function () {
      _this.setState({
        isFocused: false
      });
    };
    _this.completeSuggestion = function (searchTerm) {
      var _this$props = _this.props,
        shouldClearFilters = _this$props.shouldClearFilters,
        setSearchTerm = _this$props.setSearchTerm;
      setSearchTerm(searchTerm, {
        shouldClearFilters: shouldClearFilters
      });
    };
    _this.handleSubmit = function (e) {
      var _this$props2 = _this.props,
        shouldClearFilters = _this$props2.shouldClearFilters,
        searchTerm = _this$props2.searchTerm,
        setSearchTerm = _this$props2.setSearchTerm;
      e.preventDefault();
      setSearchTerm(searchTerm, {
        shouldClearFilters: shouldClearFilters
      });
    };
    _this.handleChange = function (value) {
      var _this$props3 = _this.props,
        autocompleteMinimumCharacters = _this$props3.autocompleteMinimumCharacters,
        autocompleteResults = _this$props3.autocompleteResults,
        autocompleteSuggestions = _this$props3.autocompleteSuggestions,
        shouldClearFilters = _this$props3.shouldClearFilters,
        searchAsYouType = _this$props3.searchAsYouType,
        setSearchTerm = _this$props3.setSearchTerm,
        debounceLength = _this$props3.debounceLength;
      var options = Object.assign(Object.assign({
        autocompleteMinimumCharacters: autocompleteMinimumCharacters
      }, (autocompleteResults || autocompleteSuggestions || searchAsYouType) && {
        debounce: debounceLength || 200
      }), {
        shouldClearFilters: shouldClearFilters,
        refresh: !!searchAsYouType,
        autocompleteResults: !!autocompleteResults,
        autocompleteSuggestions: !!autocompleteSuggestions
      });
      setSearchTerm(value, options);
    };
    _this.handleNotifyAutocompleteSelected = function (selection) {
      var _a;
      var _this$props4 = _this.props,
        autocompleteResults = _this$props4.autocompleteResults,
        trackAutocompleteClickThrough = _this$props4.trackAutocompleteClickThrough,
        trackAutocompleteSuggestionClickThrough = _this$props4.trackAutocompleteSuggestionClickThrough;
      // results
      if (autocompleteResults) {
        var autocompleteResultsConfig = autocompleteResults === true ? {
          clickThroughTags: [],
          shouldTrackClickThrough: true
        } : autocompleteResults;
        if (!selection.suggestion && autocompleteResultsConfig.shouldTrackClickThrough !== false) {
          var _autocompleteResultsC = autocompleteResultsConfig.clickThroughTags,
            clickThroughTags = _autocompleteResultsC === void 0 ? [] : _autocompleteResultsC;
          var id = (_a = selection.id) === null || _a === void 0 ? void 0 : _a.raw;
          trackAutocompleteClickThrough(id, clickThroughTags);
        }
        if (selection.suggestion) {
          trackAutocompleteSuggestionClickThrough(selection.suggestion, selection.index, []);
        }
      }
    };
    _this.defaultOnSelectAutocomplete = function (selection) {
      if (!selection) return;
      var autocompleteResults = _this.props.autocompleteResults;
      _this.handleNotifyAutocompleteSelected(selection);
      if (!selection.suggestion && typeof autocompleteResults !== "boolean") {
        var url = selection[autocompleteResults.urlField] ? selection[autocompleteResults.urlField].raw : "";
        if (url) {
          var target = typeof autocompleteResults !== "boolean" && autocompleteResults.linkTarget || "_self";
          window.open(url, target);
        }
      } else {
        _this.completeSuggestion(selection.suggestion);
      }
    };
    return _this;
  }
  _createClass(SearchBoxContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var isFocused = this.state.isFocused;
      var _a = this.props,
        autocompleteMinimumCharacters = _a.autocompleteMinimumCharacters,
        autocompleteResults = _a.autocompleteResults,
        autocompleteSuggestions = _a.autocompleteSuggestions,
        autocompletedResults = _a.autocompletedResults,
        autocompletedSuggestions = _a.autocompletedSuggestions,
        className = _a.className,
        autocompleteView = _a.autocompleteView,
        inputProps = _a.inputProps,
        inputView = _a.inputView,
        onSelectAutocomplete = _a.onSelectAutocomplete,
        onSubmit = _a.onSubmit,
        searchTerm = _a.searchTerm,
        view = _a.view,
        rest = __rest(_a, ["autocompleteMinimumCharacters", "autocompleteResults", "autocompleteSuggestions", "autocompletedResults", "autocompletedSuggestions", "className", "autocompleteView", "inputProps", "inputView", "onSelectAutocomplete", "onSubmit", "searchTerm", "view"]);
      var View = view || SearchBox;
      var useAutocomplete = (!!autocompleteResults || !!autocompleteSuggestions) && searchTerm.length >= autocompleteMinimumCharacters;
      var autocompletedSuggestionsCount = Object.entries(autocompletedSuggestions
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      ).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          _ = _ref2[0],
          value = _ref2[1];
        return acc + value.length;
      }, 0);
      var allAutocompletedItemsCount = autocompletedSuggestionsCount + autocompletedResults.length;
      var handleOnSelectAutocomplete;
      if (onSelectAutocomplete) {
        handleOnSelectAutocomplete = function handleOnSelectAutocomplete(selection) {
          onSelectAutocomplete(selection, {
            notifyAutocompleteSelected: _this2.handleNotifyAutocompleteSelected,
            completeSuggestion: _this2.completeSuggestion,
            autocompleteResults: _this2.props.autocompleteResults
          }, _this2.defaultOnSelectAutocomplete);
        };
      }
      var viewProps = Object.assign({
        allAutocompletedItemsCount: allAutocompletedItemsCount,
        autocompleteView: autocompleteView,
        autocompleteResults: autocompleteResults,
        autocompleteSuggestions: autocompleteSuggestions,
        autocompletedResults: autocompletedResults,
        autocompletedSuggestions: autocompletedSuggestions,
        className: className,
        autocompletedSuggestionsCount: autocompletedSuggestionsCount,
        completeSuggestion: this.completeSuggestion,
        isFocused: isFocused,
        notifyAutocompleteSelected: this.handleNotifyAutocompleteSelected,
        onChange: function onChange(value) {
          return _this2.handleChange(value);
        },
        onSelectAutocomplete: handleOnSelectAutocomplete || this.defaultOnSelectAutocomplete,
        onSubmit: onSubmit ? function (e) {
          e.preventDefault();
          onSubmit(searchTerm);
        } : this.handleSubmit,
        useAutocomplete: useAutocomplete,
        value: searchTerm,
        inputProps: Object.assign({
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }, inputProps),
        inputView: inputView
      }, rest);
      return React.createElement(View, Object.assign({}, viewProps));
    }
  }]);
  return SearchBoxContainer;
}(Component);
SearchBoxContainer.defaultProps = {
  autocompleteMinimumCharacters: 0,
  shouldClearFilters: true
};
export default withSearch(function (_ref3) {
  var autocompletedResults = _ref3.autocompletedResults,
    autocompletedSuggestions = _ref3.autocompletedSuggestions,
    searchTerm = _ref3.searchTerm,
    setSearchTerm = _ref3.setSearchTerm,
    trackAutocompleteClickThrough = _ref3.trackAutocompleteClickThrough,
    trackAutocompleteSuggestionClickThrough = _ref3.trackAutocompleteSuggestionClickThrough;
  return {
    autocompletedResults: autocompletedResults,
    autocompletedSuggestions: autocompletedSuggestions,
    searchTerm: searchTerm,
    setSearchTerm: setSearchTerm,
    trackAutocompleteClickThrough: trackAutocompleteClickThrough,
    trackAutocompleteSuggestionClickThrough: trackAutocompleteSuggestionClickThrough
  };
})(SearchBoxContainer);